export enum EDomainReferenceType {
  WEBSITE = 'WEBSITE',
  X = 'X',
  LINKEDIN = 'LINKEDIN',
  EMAIL = 'EMAIL',
}
